import { render, staticRenderFns } from "./insheet.vue?vue&type=template&id=83009a84&scoped=true&"
import script from "./insheet.vue?vue&type=script&lang=js&"
export * from "./insheet.vue?vue&type=script&lang=js&"
import style0 from "./insheet.vue?vue&type=style&index=0&id=83009a84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83009a84",
  null
  
)

export default component.exports